<template>
    <div class="logo">
        <h1 class="text-center mb-5">{{ mensagem }}</h1>
    </div>
</template>

<script>
  import { flavorRes, loadFlavor } from '../plugins/flavors'
  import { alert } from '../plugins/helpers'

  export default {
    name: 'LoginExternoEscritorio',
    data: () => ({
      logo: '',
      mensagem: 'Autenticando...'
    }),
    mounted () {
      this.$session.destroy()
      loadFlavor('rodobens')
      this.logo = flavorRes('img/logo-menu.png')
      alert('O acesso a plataforma nesse modelo, não está mais disponível.')
      this.mensagem = 'O acesso a plataforma nesse modelo, não está mais disponível.'
    }
  }
</script>

<style scoped>
    .logo {
        width: 100%;
        margin-top: 15px;
    }

    .logo img {
        margin: auto;
        display: block;
    }
</style>
